import React from 'react';

import * as Styled from './overlay-component-wrapper.style';

export type OverlayComponentWrapperProps = {
  isOutside?: boolean;
  children: React.ReactNode;
};

export const OverlayComponentWrapper: React.FC<
  OverlayComponentWrapperProps
> = ({ isOutside = false, children }) => (
  <Styled.OverlayWrapper $isOutside={isOutside}>
    {children}
  </Styled.OverlayWrapper>
);
